/**
 * Created by tofaelraju on 10/15/17.
 */

import React from 'react';
import Header from './header';
import LeftDrawer from './left-drawer';
import ProgressBar from './progressbar';
import FeedbackBar from './feedback-bar';
import {Helmet} from 'react-helmet/es/Helmet';
import packageFile from '../../../package.json';

const Layout = ({username, id ,styles, isLoading, drawerOpen, menus, toggleNavDrawer, signOut, children, notifyUser, notificationMessage, handleRequestClose, closeFeedbackBar}) => (
  <div>
    <Helmet>
      <title>Olwel Admin Panel (v {packageFile.version})</title>
    </Helmet>
    <Header
      styles={styles.header}
      username={username}
      handleChangeRequestNavDrawer={toggleNavDrawer}
      signOut={signOut}/>
    <ProgressBar
      open={isLoading}
    />
    <LeftDrawer
      id={id}
      navDrawerOpen={drawerOpen}
      menus={menus}
      username={username}/>
    <div style={styles.container}>
      {children}
    </div>
    <FeedbackBar
      notifyUser={notifyUser}
      notificationMessage={notificationMessage}
      closeFeedbackBar={closeFeedbackBar}
    />
  </div>
);
export default Layout;



// WEBPACK FOOTER //
// ./src/screens/layout/index.js